import { CARD_PROFILE } from '../../data/card';
import { downloadVCard } from '../../utils/downloadVCard';
import './CardPage.css';

const CardDivider = () => <div className="card-divider" aria-hidden="true" />;

const CardPage = () => {
  const {
    fullName,
    title,
    headline,
    email,
    phone,
    phoneTel,
    website,
    websiteLabel,
    coverage,
    status,
    avatarSrc,
    avatarAlt,
    bio,
    disciplines,
    socials,
  } = CARD_PROFILE;

  const handleSaveContact = () => {
    downloadVCard(CARD_PROFILE);
  };

  return (
    <main className="card-page" data-testid="card-page">
      <div className="card-page-ambient" aria-hidden="true" />

      <div className="card-panel">
        <div className="card-panel-border" aria-hidden="true" />
        <div className="card-panel-inner">
          <header className="card-hero">
            <div className="card-hero-wash" aria-hidden="true" />
            <div className="card-avatar-wrap">
              <div className="card-avatar-ring" aria-hidden="true" />
              <div className="card-avatar">
                <img src={avatarSrc} alt={avatarAlt} width={128} height={128} decoding="async" />
              </div>
            </div>
          </header>

          <section className="card-identity">
            <p className="card-eyebrow">Digital card</p>
            <h1 className="card-name">{fullName}</h1>
            <p className="card-title">{title}</p>
            <p className="card-headline">{headline}</p>
            <p className="card-status">
              <span className="card-status-dot" aria-hidden="true" />
              {status}
            </p>
          </section>

          <div className="card-actions">
            <button
              type="button"
              className="card-btn card-btn-primary"
              onClick={handleSaveContact}
            >
              <span className="card-btn-label">Save contact</span>
            </button>
            <div className="card-actions-row card-actions-row--triple">
              <a className="card-btn card-btn-ghost" href={`mailto:${email}`}>
                <span className="card-btn-label">Email</span>
              </a>
              <a className="card-btn card-btn-ghost" href={`tel:${phoneTel}`}>
                <span className="card-btn-label">Call</span>
              </a>
              <a
                className="card-btn card-btn-ghost"
                href={website}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="card-btn-label">Web</span>
              </a>
            </div>
          </div>

          <CardDivider />

          <section className="card-section">
            <h2 className="card-section-label">About</h2>
            {bio.map((paragraph) => (
              <p key={paragraph.slice(0, 24)} className="card-copy">
                {paragraph}
              </p>
            ))}
          </section>

          <CardDivider />

          <section className="card-section">
            <h2 className="card-section-label">Practice</h2>
            <ul className="card-list">
              {disciplines.map((item) => (
                <li key={item.label} className="card-list-item">
                  <span className="card-list-label">{item.label}</span>
                  {item.detail ? (
                    <span className="card-list-detail">{item.detail}</span>
                  ) : null}
                </li>
              ))}
            </ul>
          </section>

          <CardDivider />

          <section className="card-section">
            <h2 className="card-section-label">Details</h2>
            <dl className="card-details">
              <div className="card-detail">
                <dt>Email</dt>
                <dd>
                  <a href={`mailto:${email}`}>{email}</a>
                </dd>
              </div>
              <div className="card-detail">
                <dt>Phone</dt>
                <dd>
                  <a href={`tel:${phoneTel}`}>{phone}</a>
                </dd>
              </div>
              <div className="card-detail">
                <dt>Website</dt>
                <dd>
                  <a href={website} target="_blank" rel="noopener noreferrer">
                    {websiteLabel}
                  </a>
                </dd>
              </div>
              <div className="card-detail">
                <dt>Coverage</dt>
                <dd>{coverage}</dd>
              </div>
            </dl>
          </section>

          <CardDivider />

          <section className="card-section card-section-social">
            <h2 className="card-section-label">Connect</h2>
            <ul className="card-socials">
              {socials.map((s) => (
                <li key={s.id}>
                  <a href={s.href} target="_blank" rel="noopener noreferrer">
                    <span>{s.label}</span>
                    <span className="card-social-arrow" aria-hidden="true">
                      ↗
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </section>

          <CardDivider />

          <footer className="card-footer">
            <span>andreafagioli.com/card</span>
          </footer>
        </div>
      </div>

      <div className="card-sticky" aria-hidden="false">
        <button
          type="button"
          className="card-btn card-btn-primary card-sticky-btn"
          onClick={handleSaveContact}
        >
          <span className="card-btn-label">Save contact</span>
        </button>
      </div>
    </main>
  );
};

export default CardPage;
